"use strict";

var cov_1ldrnc1mon = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verses\\Verses.js";
  var hash = "57641fda8bf83c8140d949839758e314dbc0d6d4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verses\\Verses.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 18
        },
        end: {
          line: 15,
          column: 29
        }
      },
      "2": {
        start: {
          line: 16,
          column: 29
        },
        end: {
          line: 16,
          column: 39
        }
      },
      "3": {
        start: {
          line: 17,
          column: 27
        },
        end: {
          line: 17,
          column: 37
        }
      },
      "4": {
        start: {
          line: 18,
          column: 25
        },
        end: {
          line: 18,
          column: 35
        }
      },
      "5": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 19,
          column: 41
        }
      },
      "6": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 28,
          column: 26
        }
      },
      "7": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "8": {
        start: {
          line: 23,
          column: 24
        },
        end: {
          line: 23,
          column: 94
        }
      },
      "9": {
        start: {
          line: 23,
          column: 68
        },
        end: {
          line: 23,
          column: 84
        }
      },
      "10": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 40
        }
      },
      "11": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 26,
          column: 26
        }
      },
      "12": {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 25,
          column: 32
        }
      },
      "13": {
        start: {
          line: 26,
          column: 11
        },
        end: {
          line: 26,
          column: 26
        }
      },
      "14": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 50,
          column: 64
        }
      },
      "15": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "16": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 47,
          column: 7
        }
      },
      "17": {
        start: {
          line: 33,
          column: 29
        },
        end: {
          line: 33,
          column: 45
        }
      },
      "18": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 42,
          column: 10
        }
      },
      "19": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "20": {
        start: {
          line: 44,
          column: 32
        },
        end: {
          line: 44,
          column: 48
        }
      },
      "21": {
        start: {
          line: 45,
          column: 11
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "22": {
        start: {
          line: 45,
          column: 36
        },
        end: {
          line: 45,
          column: 51
        }
      },
      "23": {
        start: {
          line: 46,
          column: 11
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "24": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 24
        }
      },
      "25": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 58,
          column: 4
        }
      },
      "26": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 73,
          column: 2
        }
      },
      "27": {
        start: {
          line: 75,
          column: 18
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "28": {
        start: {
          line: 75,
          column: 39
        },
        end: {
          line: 78,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 22
          },
          end: {
            line: 8,
            column: 23
          }
        },
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 13
          }
        },
        loc: {
          start: {
            line: 21,
            column: 18
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 53
          },
          end: {
            line: 23,
            column: 54
          }
        },
        loc: {
          start: {
            line: 23,
            column: 68
          },
          end: {
            line: 23,
            column: 84
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 12
          },
          end: {
            line: 30,
            column: 13
          }
        },
        loc: {
          start: {
            line: 30,
            column: 18
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 30
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 32,
            column: 32
          },
          end: {
            line: 32,
            column: 33
          }
        },
        loc: {
          start: {
            line: 32,
            column: 53
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 32
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 75,
            column: 29
          },
          end: {
            line: 75,
            column: 30
          }
        },
        loc: {
          start: {
            line: 75,
            column: 39
          },
          end: {
            line: 78,
            column: 1
          }
        },
        line: 75
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 26,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 26,
            column: 26
          }
        }, {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 26,
            column: 26
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 46,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 46,
            column: 32
          }
        }, {
          start: {
            line: 44,
            column: 6
          },
          end: {
            line: 46,
            column: 32
          }
        }],
        line: 44
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 46,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 46,
            column: 32
          }
        }, {
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 46,
            column: 32
          }
        }],
        line: 45
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "57641fda8bf83c8140d949839758e314dbc0d6d4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Verses = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _ = require(".");

var _core = require("../../core");

cov_1ldrnc1mon.s[0]++;

var Verses = function Verses(_ref) {
  var verses = _ref.verses,
      paragraphs = _ref.paragraphs,
      showUnsupported = _ref.showUnsupported,
      direction = _ref.direction,
      disableWordPopover = _ref.disableWordPopover;
  cov_1ldrnc1mon.f[0]++;
  var classes = (cov_1ldrnc1mon.s[1]++, useStyles());

  var _ref2 = (cov_1ldrnc1mon.s[2]++, (0, _react.useState)()),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      _verses = _ref3[0],
      setVerses = _ref3[1];

  var _ref4 = (cov_1ldrnc1mon.s[3]++, (0, _react.useState)()),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      _front = _ref5[0],
      setFront = _ref5[1];

  var _ref6 = (cov_1ldrnc1mon.s[4]++, (0, _react.useState)()),
      _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
      _back = _ref7[0],
      setBack = _ref7[1];

  var _ref8 = (cov_1ldrnc1mon.s[5]++, (0, _react.useState)(direction)),
      _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
      dir = _ref9[0],
      setDir = _ref9[1];

  cov_1ldrnc1mon.s[6]++;
  (0, _react.useEffect)(function () {
    cov_1ldrnc1mon.f[1]++;
    cov_1ldrnc1mon.s[7]++;

    if (!direction) {
      cov_1ldrnc1mon.b[0][0]++;
      var verseText = (cov_1ldrnc1mon.s[8]++, verses['1'].verseObjects.map(function (verseObject) {
        cov_1ldrnc1mon.f[2]++;
        cov_1ldrnc1mon.s[9]++;
        return verseObject.text;
      }).join(''));
      var hebrew = (cov_1ldrnc1mon.s[10]++, (0, _core.isHebrew)(verseText));
      cov_1ldrnc1mon.s[11]++;

      if (hebrew) {
        cov_1ldrnc1mon.b[1][0]++;
        cov_1ldrnc1mon.s[12]++;
        setDir('rtl');
      } else {
        cov_1ldrnc1mon.b[1][1]++;
        cov_1ldrnc1mon.s[13]++;
        setDir('auto');
      }
    } else {
      cov_1ldrnc1mon.b[0][1]++;
    }
  }, [verses, direction]);
  cov_1ldrnc1mon.s[14]++;
  (0, _react.useEffect)(function () {
    cov_1ldrnc1mon.f[3]++;

    var __verses = (cov_1ldrnc1mon.s[15]++, []);

    cov_1ldrnc1mon.s[16]++;
    Object.keys(verses).forEach(function (verseKey, index) {
      cov_1ldrnc1mon.f[4]++;

      var _ref10 = (cov_1ldrnc1mon.s[17]++, verses[verseKey]),
          verseObjects = _ref10.verseObjects;

      var verse = (cov_1ldrnc1mon.s[18]++, _react.default.createElement(_.Verse, {
        key: index,
        verseKey: verseKey,
        verseObjects: verseObjects,
        paragraphs: paragraphs,
        showUnsupported: showUnsupported,
        disableWordPopover: disableWordPopover
      }));
      cov_1ldrnc1mon.s[19]++;

      if (verseKey === 'front') {
        cov_1ldrnc1mon.b[2][0]++;
        cov_1ldrnc1mon.s[20]++;
        setFront(verse);
      } else {
        cov_1ldrnc1mon.b[2][1]++;
        cov_1ldrnc1mon.s[21]++;

        if (verseKey === 'back') {
          cov_1ldrnc1mon.b[3][0]++;
          cov_1ldrnc1mon.s[22]++;
          setBack(verse);
        } else {
          cov_1ldrnc1mon.b[3][1]++;
          cov_1ldrnc1mon.s[23]++;

          __verses.push(verse);
        }
      }
    });
    cov_1ldrnc1mon.s[24]++;
    setVerses(__verses);
  }, [verses, paragraphs, showUnsupported, disableWordPopover]);
  cov_1ldrnc1mon.s[25]++;
  return _react.default.createElement("div", {
    className: classes.verses,
    dir: dir
  }, _front, _verses, _back);
};

exports.Verses = Verses;
cov_1ldrnc1mon.s[26]++;
Verses.propTypes = {
  verses: _propTypes.default.object.isRequired,

  /** render verses paragraphs, use explicit paragraphs */
  paragraphs: _propTypes.default.bool,

  /** bypass rendering only when visible */
  renderOffscreen: _propTypes.default.bool,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** override text direction detection */
  direction: _propTypes.default.string,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var useStyles = (cov_1ldrnc1mon.s[27]++, (0, _styles.makeStyles)(function (theme) {
  cov_1ldrnc1mon.f[5]++;
  cov_1ldrnc1mon.s[28]++;
  return {
    verses: {}
  };
}));
var _default = Verses;
exports.default = _default;